import { BulkExportType } from "@nens/ldo/api-v1";

export function getBulkExportListUrl(exportType: BulkExportType) {
  return exportType === "bulk_file"
    ? "/export/scenarios"
    : exportType === "composite_map"
    ? "/export/composite"
    : "/export/ror";
}

export function getBulkExportUrl(exportType: BulkExportType, id: number) {
  const listUrl = getBulkExportListUrl(exportType);
  return `${listUrl}/${id}`;
}

export function getBulkExportCloneUrl(exportType: BulkExportType, id: number) {
  const listUrl = getBulkExportListUrl(exportType);
  return `${listUrl}/clone/${id}`;
}
